(function( root, $, undefined ) {

    $(function () {
        // DOM ready, take it away

        // Mobile menu
        $('.mobile-menu-trigger').click(function(e){
            e.preventDefault();
            $(this).toggleClass('active');
            $('.top-bar-menu').toggleClass('active');
        })

        $('#main-nav a').click(function(){
            if($('.mobile-menu-trigger').css('display') == 'block') {
                $('.top-bar-menu, .mobile-menu-trigger').removeClass('active');
            }
        })

        if(!$('body').hasClass('home')) {
          $('.menu-item a').each(function(){
            if($(this).attr('href').charAt(0) == '#') {
              $(this).attr('href', '/' + $(this).attr('href'));
            }
          });
        }

        function adjustVH() {
            var windowHeight = window.innerHeight;
            $('.header .top-bar .top-bar-menu').css('height', windowHeight + 'px');
        }
        adjustVH();
        window.onresize = adjustVH;

        // Adjust sections decors
        function adjustDecors() {
            if($('.about-decor').length > 0) {
                var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                $('.about-decor > span').width(vw - $('.about-decor').offset().left);
                $('.career-decor span').width($('.career-right-content').offset().left);
            }
        }
        adjustDecors();
        $(window).resize(adjustDecors);

        // Header Scrolled
        $(window).scroll(function(){
            if ($(this).scrollTop() >= 40) {
                $('.header').addClass('scrolled');
            } else {
                $('.header').removeClass('scrolled');
            }
        });

        // News trigger
        $('.news-trigger a').click(function(){
            $('.news-wrapper').slideDown();
            ScrollReveal().sync();
        })

        // Mobile TEAM
        $('.mobile-team-expand').click(function(){
            $('.team-listing .cell:not(.mobile-visible):lt(3)').addClass('mobile-visible');
            if($('.team-listing .cell:not(.mobile-visible)').length < 1) $('.mobile-team-expand').hide();
        });

        // Team reveal sizing
        function adjustReveal() {
            if($('.about-decor').length > 0) {
                var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                var padding = vw - $('.team-listing').offset().left - $('.team-listing').width() - parseInt($('.team-listing').css('padding-left'));
                $('.team-reveal').css('padding-right', ( padding - 20 ) + 'px');
            }
        }
         adjustReveal();
         $(window).resize(adjustReveal);

        // Reveal
        ScrollReveal().reveal('.hero .sr, .about .sr', {
            interval: 250,
            duration: 1000,
            delay: 1000,
            distance: '20px',
            opacity: 0,
            viewFactor: 0,
            mobile: 'false',
            origin: 'left'
        });

        ScrollReveal().reveal('', {
            interval: 250,
            duration: 1000,
            delay: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0,
            mobile: 'false'
        });

        ScrollReveal().reveal('.team .sr', {
            interval: 250,
            duration: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0.25,
            mobile: 'false'
        });

        ScrollReveal().reveal('.services .sr', {
            interval: 250,
            duration: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0.25,
            mobile: 'false'
        });

        ScrollReveal().reveal('.news .sr', {
            interval: 250,
            duration: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0.25,
            mobile: 'false'
        });

        ScrollReveal().reveal('.career .sr', {
            interval: 250,
            duration: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0.25,
            mobile: 'false'
        });

        ScrollReveal().reveal('.contact .sr', {
            interval: 250,
            duration: 1000,
            distance: '20px',
            origin: 'left',
            opacity: 0,
            viewFactor: 0.25,
            mobile: 'false'
        });

        function calculateMobileScale() {
            var baseSize = 670;
            var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            if(vw < baseSize) {
                if((vw/baseSize)*100 < 55) {
                    $('html').css('font-size', '55%');
                } else {
                    $('html').css('font-size', parseInt((vw/baseSize)*100) + '%');
                }
            } else {
                $('html').css('font-size', '');
            }
        }
        calculateMobileScale();
        $(window).resize(calculateMobileScale);

    });

} ( this, jQuery ));
